import { create } from 'zustand';
import { persist, subscribeWithSelector } from 'zustand/middleware';

export const useGlobalPersistentStore = create(
  subscribeWithSelector(
    persist(
      (set, get) => ({
        data: {},
        setValue: (key, value) => {
          set((state) => ({
            data: {
              ...state.data,
              [key]: value
            }
          }))
        },
        getValue: (key) => get().data[key],
        clear: (key) => {
          set((state) => {
            const newData = { ...state.data };
            delete newData[key];
            return { data: newData };
          })
        },
        clearAll: () => {
          set({ data: {} })
        }
      }),
      {
        name: 'welm-global-persistent-storage',
      }
    )
  )
);
